import styled from 'styled-components'

import { up } from '@Globals/Style/breakpoints'
import {
  box,
  flexCenterChildren,
  sectionInner,
  smoothScroll,
} from '@Globals/Style/mixins'

export const Wrapper = styled.div`
  overflow: auto;
  height: calc(100% - 60px);
  padding: 20px 20px 100px;

  ${smoothScroll}
  ${up('desktop')} {
    ${sectionInner}
    display: flex;
    min-height: 260px;
    padding: 15px 20px 15px;
    /* TODO: Add white to colors */
    background-color: #fff;
    /* TODO: Include in theme/colors system as greyLightest darkened 5% */
    border: 1px solid #e8e8e8;
    border-top: none;
    box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.05);
  }

  &.selectedItem {
    background-color: ${({ theme }) => theme.colors.greyLightest};
  }

  .title {
    color: ${({ theme }) => theme.colors.greyDark};
    display: block;
    font-size: 0.75rem;
    text-transform: uppercase;
    margin-bottom: 10px;
  }

  .searchResultsCategories {
    margin-bottom: 20px;

    ${up('desktop')} {
      width: 50%;
      flex-shrink: 0;
    }

    ${up('maxWidth')} {
      width: 60%;
    }
  }

  .searchResultsCategoriesItem {
    display: flex;
    align-items: center;
    padding: 8px 0;
    cursor: pointer;

    ${up('desktop')} {
      padding: 8px 10px;
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.greyLightest};
    }

    &.freeText .svgIconWrapper {
      transform: rotateZ(0deg);
    }

    .arrowRightThinIconWrapper, .searchIconWrapper {
      ${box({ width: '16px' })}
      ${flexCenterChildren}
      flex-shrink: 0;
      margin-right: 8px;

      svg {
        fill: ${({ theme }) => theme.colors.grey};
      }
    }

    .arrowRightThinIconWrapper {
      transform: rotateZ(-135deg);
    }

    .searchAllArrowRightThinIconWrapper {
      ${flexCenterChildren}
      margin: 0 6px;

      ${up('desktop')} {
        ${box({ width: '12px' })}
      }

      svg {
        fill: ${({ theme }) => theme.colors.grey};
      }
    }

    .searchAll {
      color: ${({ theme }) => theme.colors.grey};
    }

    .textWrapper {
      flex-grow: 2;

      .innerText {
        font-size: 0;

        span {
          display: inline;
        }

        .divideIcon {
          ${flexCenterChildren}
          display: inline-flex;
          margin: 0 5px;

          svg {
            fill: ${({ theme }) => theme.colors.grey};
          }
        }
      }
    }

    span, b, em {
      font-size: 1rem;
      font-style: normal;
    }

    em {
      background-color: transparent;
      font-weight: bold;
    }
  }

  .brandAndCategoryWrapper {
    display: flex;
    flex-direction: column-reverse;

    ${up('desktop')} {
      margin-left: 20px;
      width: calc(50% - 20px);
      flex-direction: column;
    }

    ${up('maxWidth')} {
      width: calc(40% - 20px);
    }
  }

  .products {
    ${up('desktop')} {
      flex-grow: 2;
      max-width: 100%;
    }
  }

  .brands, .products {
    margin-bottom: 20px;

    .title {
      display: block;
      width: 100%;
      padding-bottom: 4px;
      font-size: 0.75rem;
      font-weight: bold;
      text-transform: uppercase;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey};
    }

    .nothingToShowText {
      color: ${({ theme }) => theme.colors.grey};
      font-size: 0.75rem;
    }

    .searchResultsProductItem {
      display: flex;
      margin-bottom: 10px;
      cursor: pointer;
      padding-right: 10px;

      ${up('desktop')} {
        margin-bottom: 5px;
        max-width: 100%;
      }

      &:hover {
        background-color: ${({ theme }) => theme.colors.greyLightest};
      }

      .imgWrap {
        position: relative;
        flex-shrink: 0;
        ${box({ width: '50px' })};
        margin-right: 10px;

        ${up('desktop')} {
          ${box({ width: '45px' })}
        }

        &::after {
          content: '';
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.04);
        }
      }

      .infoWrap {
        display: flex;
        align-items: center;
        flex-grow: 2;

        span {
          line-height: 2;

          ${up('desktop')} {
            line-height: 1.2;
          }
        }

        em {
          background-color: transparent;
          font-weight: bold;
          font-style: normal;
        }
      }

      .priceWrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        flex-shrink: 0;
        padding-left: 20px;

        span {
          line-height: 1.2;
        }

        .beforePrice {
          font-weight: bold;
          text-decoration: line-through;
        }

        .discountPrice {
          font-weight: bold;
          color: ${({ theme }) => theme.colors.red};
        }

        .normalPrice {
          font-weight: bold;
        }
      }
    }

    .searchResultsBrandItem {
      display: flex;
      align-items: center;
      padding: 8px 0;
      cursor: pointer;

      ${up('desktop')} {
        display: inline-block;
        padding: 5px 5px 4px;
        border: 1px solid ${({ theme }) => theme.colors.greyLight};
        margin-right: 5px;
        margin-bottom: 5px;
      }

      .arrowIcon {
        ${flexCenterChildren}
        flex-shrink: 0;
        margin-right: 8px;
        transform: rotateZ(-135deg);

        ${up('desktop')} {
          display: none;
        }

        svg {
          fill: ${({ theme }) => theme.colors.grey};
        }
      }

      em {
        background-color: transparent;
        font-weight: bold;
        font-style: normal;
      }
    }
  }
`
